import { FC } from "react";
import type {  BaseFilter } from "src/constants";
import Section from "./components/Section";
import { TimeSegments } from "src/components/Filters";

const FILTER_COMPONENTS = {
  TimeSegments: TimeSegments,
};

export const StaticFilters: FC<{filters:BaseFilter[]}> = ({filters}) => {
  return filters.map((filter) => {
    const Component = FILTER_COMPONENTS[filter.component as keyof typeof FILTER_COMPONENTS];
    if (!Component) return null;
    return (
      <Section label={filter.title} key={filter.key} >
            <Component filter={filter}/>
      </Section>
    );
  });
};